import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Modal, IconButton, List, ListItemText, Divider } from '@mui/material';
import doctorimagelocal from '../assets/images/doctor-png-1.png';
import hospitalimagelocal from '../assets/images/11215024.jpg';
import ImageShow from '../Uitiles/ImageShow';
import { Message, Timer, Bookmark, Receipt, Article, AccountBalance, MedicalServices, Close, EventNote } from '@mui/icons-material';
import { getDoctorsCount, getHospitalsCount, getPatientsCount, getStaffCount, getNewRegistrationsCount, getrecentActivities, getAppointments } from '../controllers/Admin/DashbordController';
import { oneKlicks } from '../SDK/oneclick';
import { Container, Row, Alert, Badge, Button, Progress, Table, Flex, Spacer, Link, CardView, Grid, ListView, ListItem, RowView, Col, Heading, Text } from '../layouts/MainCompontes/index';
import * as XLSX from 'xlsx';
import { Dropdown, Menu } from 'antd';
import { DownloadOutlined, FileExcelOutlined, FileTextOutlined } from '@ant-design/icons';

const Dashboard = () => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [doctorsCount, setDoctorsCount] = useState(0);
    const [hospitalsCount, setHospitalsCount] = useState(0);
    const [patientsCount, setPatientsCount] = useState(0);
    const [staffCount, setStaffCount] = useState(0);
    const [newRegistrationsCount, setNewRegistrationsCount] = useState(0);
    const [revenue, setRevenue] = useState(0);
    const [revenueLoading, setRevenueLoading] = useState(true);
    const [expenses, setExpenses] = useState(0);
    const [expensesLoading, setExpensesLoading] = useState(true);
    const [staff, setStaff] = useState(0);
    const [patients, setPatients] = useState(0);
    const [netProfit, setNetProfit] = useState(0);
    const [recentActivities, setRecentActivities] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [appointmentsLoading, setAppointmentsLoading] = useState(true);

    const [showModal, setShowModal] = useState(false);
    const [notifications, setNotifications] = useState(5);


    //  // Recent orders data
    const recentOrders = [
        { id: '#12345', customer: 'John Doe', product: 'Product A', amount: '$125.00', status: 'Completed' },
        { id: '#12346', customer: 'Jane Smith', product: 'Product B', amount: '$89.50', status: 'Pending' },
        { id: '#12347', customer: 'Bob Johnson', product: 'Product C', amount: '$220.00', status: 'Completed' },
        { id: '#12348', customer: 'Alice Williams', product: 'Product D', amount: '$156.75', status: 'Processing' },
        { id: '#12349', customer: 'Charlie Brown', product: 'Product E', amount: '$99.00', status: 'Completed' }
    ];

    // Recent activities
    const activities = [
        { icon: '✅', text: 'New order received', time: '2 minutes ago', type: 'success' },
        { icon: '👤', text: 'New user registered', time: '15 minutes ago', type: 'info' },
        { icon: '📦', text: 'Product updated', time: '1 hour ago', type: 'primary' },
        { icon: '💬', text: 'New message from support', time: '2 hours ago', type: 'warning' },
        { icon: '🔔', text: 'System maintenance scheduled', time: '5 hours ago', type: 'danger' }
    ];

    // Stats data
    const [stats, setStats] = useState([
        {
            title: 'Total Revenue',
            value: '$45,231',
            change: '+12.5%',
            changeType: 'positive',
            icon: '💰',
            bg: 'primary'
        },
        {
            title: 'New Users',
            value: '1,234',
            change: '+8.2%',
            changeType: 'positive',
            icon: '👥',
            bg: 'success'
        },
        {
            title: 'Total Doctors',
            value: doctorsCount,
            change: '+8.2%',
            changeType: 'positive',
            icon: '�‍⚕️',
            bg: 'success'
        },
        {
            title: 'Orders',
            value: '892',
            change: '-3.1%',
            changeType: 'negative',
            icon: '📦',
            bg: 'warning'
        },
        {
            title: 'Conversion Rate',
            value: '3.45%',
            change: '+1.2%',
            changeType: 'positive',
            icon: '📈',
            bg: 'info'
        },
        {
            title: 'Total Appointments',
            value: '0',
            change: '+0%',
            changeType: 'positive',
            icon: '📅',
            bg: 'secondary'
        }
    ]);


    useEffect(() => {
        const fetchDoctorsCount = async () => {
            const doctorsCount = await getDoctorsCount();
            const hospitalsCount = await getHospitalsCount();
            const patientsCount = await getPatientsCount();
            const staffCount = await getStaffCount();
            const newRegistrationsCount = await getNewRegistrationsCount();
            setDoctorsCount(doctorsCount.count);
            console.log('doctorsCount :', doctorsCount);
            setStats(stats.map(stat => {
                if (stat.title === 'Total Doctors') {
                    return { ...stat, value: doctorsCount.count, change: '+8.2%' };
                }
                return stat;
            }));
            setHospitalsCount(hospitalsCount.count);
            setPatientsCount(patientsCount.count);
            setStaffCount(staffCount.count);
            setNewRegistrationsCount(newRegistrationsCount);
            const recentActivities = await getrecentActivities(1, 10);
            console.log('recentActivities :', recentActivities);
            setRecentActivities(recentActivities.data);

            setAppointmentsLoading(true);
            const appointmentsRes = await getAppointments(1, 8); // Changed limit to 8
            if (appointmentsRes.success) {
                setAppointments(appointmentsRes.data);
                setStats(prevStats => prevStats.map(stat => {
                    if (stat.title === 'Total Appointments') {
                        return { ...stat, value: appointmentsRes.totalCount || 0, change: '+5.4%' };
                    }
                    return stat;
                }));
            }
            setAppointmentsLoading(false);
        };

        const fetchTotalRevenue = async () => {
            try {
                setRevenueLoading(true);
                const tableSchema = "";
                const tableName = "income";
                const conditions = { status: "active" };
                const orderBy = "id DESC";
                const search = {};
                const pagination = {};
                const margedata = [];

                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

                if (response.success && response.data) {
                    const totalRevenue = response.data.reduce((sum, income) => {
                        return sum + parseFloat(income.amount || 0);
                    }, 0);
                    setRevenue(totalRevenue);
                    console.log('totalRevenue :', totalRevenue);
                    setStats(stats.map(stat => {
                        if (stat.title === 'Total Revenue') {
                            return { ...stat, value: totalRevenue, change: '+12.5%' };
                        }
                        return stat;
                    }));
                } else {
                    setRevenue(0);
                }
            } catch (error) {
                console.error('Error fetching total revenue:', error);
                setRevenue(0);
            } finally {
                setRevenueLoading(false);
            }
        };

        const fetchTotalExpenses = async () => {
            try {
                setExpensesLoading(true);
                const tableSchema = "";
                const tableName = "expenses";
                const conditions = { status: "active" };
                const orderBy = "id DESC";
                const search = {};
                const pagination = {};
                const margedata = [];

                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

                if (response.success && response.data) {
                    const totalExpenses = response.data.reduce((sum, expense) => {
                        return sum + parseFloat(expense.amount || 0);
                    }, 0);
                    setExpenses(totalExpenses);
                } else {
                    setExpenses(0);
                }
            } catch (error) {
                console.error('Error fetching total expenses:', error);
                setExpenses(0);
            } finally {
                setExpensesLoading(false);
            }
        };

        fetchDoctorsCount();
        fetchTotalRevenue();
        fetchTotalExpenses();
    }, []);

    // Calculate net profit when revenue or expenses change
    useEffect(() => {
        const profit = revenue - expenses;
        setNetProfit(profit);
    }, [revenue, expenses]);

    const formatCurrency = (amount) => {
        if (amount >= 1000000000) {
            return `₹${(amount / 1000000000).toFixed(1)}B`;
        } else if (amount >= 10000000) {
            return `₹${(amount / 10000000).toFixed(1)}Cr`;
        } else if (amount >= 100000) {
            return `₹${(amount / 100000).toFixed(1)}L`;
        } else if (amount >= 1000) {
            return `₹${(amount / 1000).toFixed(1)}K`;
        } else {
            return `₹${amount.toFixed(0)}`;
        }
    };

    const handleExport = (type) => {
        if (!appointments || appointments.length === 0) return;

        const data = appointments.map(appt => ({
            "ID": `#${appt.id}`,
            "Patient": (appt.patient?.[0]?.first_name || appt.patient?.[0]?.display_name)
                ? `${appt.patient?.[0]?.first_name || ''} ${appt.patient?.[0]?.last_name || ''}`.trim() || appt.patient?.[0]?.display_name
                : "N/A",
            "Doctor": appt.doctor?.[0]?.display_name || "N/A",
            "Hospital": appt.hospital?.[0]?.display_name || "N/A",
            "Date": appt.appointment_date,
            "Time": appt.appointment_time,
            "Status": appt.status || 'Scheduled'
        }));

        if (type === 'excel') {
            const worksheet = XLSX.utils.json_to_sheet(data);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Recent Appointments");
            XLSX.writeFile(workbook, "recent_appointments.xlsx");
        } else {
            const headers = Object.keys(data[0]);
            const rows = data.map(item => headers.map(header => item[header]));
            const csvContent = [headers.join(","), ...rows.map(r => r.join(","))].join("\n");

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.setAttribute("href", url);
            link.setAttribute("download", "recent_appointments.csv");
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const exportItems = [
        { key: 'csv', label: 'CSV File', icon: <FileTextOutlined /> },
        { key: 'excel', label: 'Excel File', icon: <FileExcelOutlined /> }
    ];

    const handleOpen = (item) => {
        setSelectedItem(item);
        setOpen(true);
    };

    return (
        <>
            {/* Main Dashboard Content */}
            <Container fluid>
                {/* Welcome Alert */}
                <Alert variant="info" dismissible>
                    <strong>👋 Welcome back!</strong> You have {notifications} new notifications.
                </Alert>

                {/* Stats Cards */}
                <RowView xs={1} sm={2} lg={4} className="gap-1">
                    {stats.map((stat, index) => (
                        <Col key={index}>
                            <CardView
                                bg={stat.bg}
                                text="white"
                                style={{ height: '100%' }}
                            >
                                <Flex justify="space-between" align="center">
                                    <div>
                                        <Text tag="div" style={{ fontSize: '14px', opacity: 0.9 }}>
                                            {stat.title}
                                        </Text>
                                        <Heading level={2} style={{ margin: '10px 0', color: 'white' }}>
                                            {stat.value}
                                        </Heading>
                                        <Badge
                                            bg={stat.changeType === 'positive' ? 'success' : 'danger'}
                                            style={{ fontSize: '12px' }}
                                        >
                                            {stat.change}
                                        </Badge>
                                    </div>
                                    <div style={{ fontSize: '40px', opacity: 0.8 }}>
                                        {stat.icon}
                                    </div>
                                </Flex>
                            </CardView>
                        </Col>
                    ))}
                </RowView>

                <Spacer height="30px" />

                {/* Charts and Progress Section */}
                <RowView>
                    <Col md={8}>
                        <CardView title="Sales Overview" subtitle="Monthly performance">
                            <Spacer height="10px" />

                            {/* Simulated Chart with Progress Bars */}
                            <div>
                                <Flex justify="space-between" align="center">
                                    <Text>January</Text>
                                    <Text>$12,450</Text>
                                </Flex>
                                <Progress now={85} variant="primary" style={{ height: '20px' }} />
                                <Spacer height="15px" />

                                <Flex justify="space-between" align="center">
                                    <Text>February</Text>
                                    <Text>$15,680</Text>
                                </Flex>
                                <Progress now={92} variant="success" style={{ height: '20px' }} />
                                <Spacer height="15px" />

                                <Flex justify="space-between" align="center">
                                    <Text>March</Text>
                                    <Text>$18,230</Text>
                                </Flex>
                                <Progress now={98} variant="info" style={{ height: '20px' }} />
                                <Spacer height="15px" />

                                <Flex justify="space-between" align="center">
                                    <Text>April</Text>
                                    <Text>$11,340</Text>
                                </Flex>
                                <Progress now={70} variant="warning" style={{ height: '20px' }} />
                            </div>

                            <Spacer height="20px" />
                            <Flex gap="10px">
                                <Button variant="primary" size="sm">View Details</Button>
                                <Button variant="outline-secondary" size="sm">Export</Button>
                            </Flex>
                        </CardView>
                    </Col>

                    <Col md={4}>
                        <CardView title="Recent Activity" subtitle="Latest updates">
                            <ListView variant="flush">
                                {activities.map((activity, index) => (
                                    <ListItem key={index}>
                                        <Flex gap="10px" align="start">
                                            <span style={{ fontSize: '20px' }}>{activity.icon}</span>
                                            <div style={{ flex: 1 }}>
                                                <Text tag="div" style={{ fontWeight: '500' }}>
                                                    {activity.text}
                                                </Text>
                                                <Text tag="small" style={{ color: '#6c757d' }}>
                                                    {activity.time}
                                                </Text>
                                            </div>
                                        </Flex>
                                    </ListItem>
                                ))}
                            </ListView>
                            <Spacer height="15px" />
                            <Link to="/activity">View all activity →</Link>
                        </CardView>
                    </Col>
                </RowView>

                <Spacer height="30px" />

                {/* Recent Orders Table */}
                <CardView title="Recent Orders" subtitle="Latest transactions">
                    <Table striped bordered hover responsive>
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Customer</th>
                                <th>Product</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recentOrders.map((order, index) => (
                                <tr key={index}>
                                    <td><strong>{order.id}</strong></td>
                                    <td>{order.customer}</td>
                                    <td>{order.product}</td>
                                    <td><strong>{order.amount}</strong></td>
                                    <td>
                                        <Badge
                                            bg={
                                                order.status === 'Completed' ? 'success' :
                                                    order.status === 'Pending' ? 'warning' :
                                                        'info'
                                            }
                                        >
                                            {order.status}
                                        </Badge>
                                    </td>
                                    <td>
                                        <Flex gap="5px">
                                            <Button variant="outline-primary" size="sm">
                                                View
                                            </Button>
                                            <Button variant="outline-secondary" size="sm">
                                                Edit
                                            </Button>
                                        </Flex>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <Spacer height="15px" />
                    <Flex justify="space-between" align="center">
                        <Text>Showing 5 of 892 orders</Text>
                        <Button variant="primary">View All Orders</Button>
                    </Flex>
                </CardView>

                <Spacer height="30px" />

                {/* Additional Widgets */}
                <RowView xs={1} md={2} lg={3}>
                    <Col>
                        <CardView title="Quick Actions">
                            <Grid columns="repeat(2, 1fr)" gap="10px">
                                <Button variant="primary" onClick={() => setShowModal(true)}>
                                    ➕ New Order
                                </Button>
                                <Button variant="success">
                                    👤 Add User
                                </Button>
                                <Button variant="info">
                                    📦 Add Product
                                </Button>
                                <Button variant="warning">
                                    📊 Generate Report
                                </Button>
                            </Grid>
                        </CardView>
                    </Col>

                    <Col>
                        <CardView title="System Status">
                            <Flex direction="column" gap="15px">
                                <div>
                                    <Flex justify="space-between" style={{ marginBottom: '10px' }}>
                                        <Text>Server Status</Text>
                                        <Badge bg="success">Online</Badge>
                                    </Flex>
                                    <Progress now={100} variant="success" style={{ height: '5px' }} />
                                </div>

                                <div>
                                    <Flex justify="space-between" style={{ marginBottom: '10px' }}>
                                        <Text>Database</Text>
                                        <Badge bg="success">Connected</Badge>
                                    </Flex>
                                    <Progress now={100} variant="success" style={{ height: '5px' }} />
                                </div>

                                <div>
                                    <Flex justify="space-between" style={{ marginBottom: '10px' }}>
                                        <Text>Storage</Text>
                                        <Badge bg="warning">75%</Badge>
                                    </Flex>
                                    <Progress now={75} variant="warning" style={{ height: '5px' }} />
                                </div>

                                <div>
                                    <Flex justify="space-between" style={{ marginBottom: '10px' }}>
                                        <Text>API Status</Text>
                                        <Badge bg="success">Active</Badge>
                                    </Flex>
                                    <Progress now={100} variant="success" style={{ height: '5px' }} />
                                </div>
                            </Flex>
                        </CardView>
                    </Col>

                    <Col>
                        <CardView title="Support Tickets">
                            <Flex direction="column" gap="15px">
                                <Flex justify="space-between" align="center">
                                    <div>
                                        <Text tag="div" style={{ fontWeight: 'bold' }}>Open</Text>
                                        <Heading level={3} style={{ margin: '5px 0' }}>23</Heading>
                                    </div>
                                    <Badge bg="danger" pill style={{ fontSize: '16px' }}>
                                        High Priority
                                    </Badge>
                                </Flex>

                                <Divider />

                                <Flex justify="space-between">
                                    <Text>In Progress</Text>
                                    <Badge bg="warning">15</Badge>
                                </Flex>

                                <Flex justify="space-between">
                                    <Text>Resolved Today</Text>
                                    <Badge bg="success">42</Badge>
                                </Flex>

                                <Spacer height="10px" />
                                <Button variant="outline-primary" block>
                                    View All Tickets
                                </Button>
                            </Flex>
                        </CardView>
                    </Col>
                </RowView>

                <Spacer height="50px" />
            </Container>

            <section className="dc-haslayout dc-dbsectionspace">
                <div className="">
                    <div className="dc-haslayout dc-jobpostedholder" style={{ width: '99%' }}>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <div className="dc-insightsitem dc-dashboardbox">
                                <span><em className="dcunread-count">{doctorsCount}</em></span>
                                <figure className="dc-userlistingimg">
                                    <img src={doctorimagelocal} alt="Total Doctors" style={{ height: '60px', width: '60px' }} />
                                </figure>
                                <div className="dc-insightdetails">
                                    <div className="dc-title">
                                        <h3>Total Doctors</h3>
                                        <a href="//css.meddylist.com//dashboard/?ref=doctors">View All Doctors</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <div className="dc-insightsitem dc-dashboardbox">
                                <span><em className="dcunread-count">{hospitalsCount}</em></span>
                                <figure className="dc-userlistingimg">
                                    <img src={hospitalimagelocal} alt="Total Hospitals" style={{ height: '60px', width: '60px' }} />
                                </figure>
                                <div className="dc-insightdetails">
                                    <div className="dc-title">
                                        <h3>Total Hospitals</h3>
                                        <a href="//css.meddylist.com//dashboard/?ref=hospitals">View All Hospitals</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <div className="dc-insightsitem dc-dashboardbox">
                                <span><em className="dcunread-count">
                                    {revenueLoading ? 'Loading...' : formatCurrency(revenue)}
                                </em></span>
                                <figure className="dc-userlistingimg">
                                    <img src="//css.meddylist.com//wp-content/uploads/2019/08/img-22.png" alt="Total Revenue" />
                                </figure>
                                <div className="dc-insightdetails">
                                    <div className="dc-title">
                                        {revenueLoading ? 'Loading...' : formatCurrency(revenue)}
                                        <h3>Total Revenue</h3>
                                        <a href="//css.meddylist.com//dashboard/?ref=revenue">View Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <div className="dc-insightsitem dc-dashboardbox">
                                <span><em className="dcunread-count">
                                    {expensesLoading ? 'Loading...' : formatCurrency(expenses)}
                                </em></span>
                                <figure className="dc-userlistingimg">
                                    <img src="//css.meddylist.com//wp-content/uploads/2019/10/invoice.png" alt="Total Expenses" />
                                </figure>
                                <div className="dc-insightdetails">
                                    <div className="dc-title">
                                        {expensesLoading ? 'Loading...' : formatCurrency(expenses)}
                                        <h3>Total Expenses</h3>
                                        <a href="//css.meddylist.com//dashboard/?ref=expenses">View Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <div className="dc-insightsitem dc-dashboardbox">
                                <span><em className="dcunread-count">{staffCount}</em></span>
                                <figure className="dc-userlistingimg">
                                    <img src="//css.meddylist.com//wp-content/uploads/2019/10/list.png" alt="Total Staff" />
                                </figure>
                                <div className="dc-insightdetails">
                                    <div className="dc-title">
                                        <h3>Total Staff</h3>
                                        <a href="//css.meddylist.com//dashboard/?ref=staff">View All Staff</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <div className="dc-insightsitem dc-dashboardbox">
                                <span><em className="dcunread-count">{patientsCount}</em></span>
                                <figure className="dc-userlistingimg">
                                    <img src="//css.meddylist.com//wp-content/uploads/2019/10/writing.png" alt="Total Patients" />
                                </figure>
                                <div className="dc-insightdetails">
                                    <div className="dc-title">
                                        <h3>Total Patients</h3>
                                        <span>Registered this month</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <div className="dc-insightsitem dc-dashboardbox">
                                <span><em className="dcunread-count" style={{
                                    color: netProfit >= 0 ? '#28a745' : '#dc3545'
                                }}>
                                    {revenueLoading || expensesLoading ? 'Loading...' : formatCurrency(netProfit)}
                                </em></span>
                                <figure className="dc-userlistingimg">
                                    <img src="//css.meddylist.com//wp-content/uploads/2025/02/balance-10.png" alt="Net Profit" />
                                </figure>
                                <div className="dc-insightdetails">
                                    <div className="dc-title">
                                        <h3>Net Profit</h3>
                                        <span>This month</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3">
                            <div className="dc-insightsitem dc-dashboardbox">
                                <span><em className="dcunread-count">{newRegistrationsCount}</em></span>
                                <figure className="dc-userlistingimg">
                                    <img src="//css.meddylist.com//wp-content/uploads/2019/10/support.png" alt="New Registrations" />
                                </figure>
                                <div className="dc-insightdetails">
                                    <div className="dc-title">
                                        <h3>New Registrations</h3>
                                        <a href="//css.meddylist.com//dashboard/?ref=registrations">View Details</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Spacer height="30px" />

                    <div className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="dc-dashboardbox dc-dashboardtabsholder d-flex flex-column gap-2">
                            <div className="dc-dashboardboxtitle d-flex justify-content-between align-items-center">
                                <h2>Recent Appointments</h2>
                                <div className="d-flex gap-2">
                                    <Dropdown
                                        menu={{
                                            items: exportItems,
                                            onClick: ({ key }) => handleExport(key)
                                        }}
                                        placement="bottomRight"
                                    >
                                        <Button variant="outline-success" size="sm">
                                            <DownloadOutlined /> Export
                                        </Button>
                                    </Dropdown>
                                    <Button variant="primary" size="sm" onClick={() => navigate('/admin/appointments')}>View All</Button>
                                </div>
                            </div>
                            {appointmentsLoading ? (
                                <div className="text-center p-5">
                                    <Progress now={100} animated label="Loading Appointments..." />
                                </div>
                            ) : appointments && appointments.length > 0 ? (
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Patient</th>
                                                <th>Doctor</th>
                                                <th>Hospital</th>
                                                <th>Date & Time</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {appointments.map((appt) => (
                                                <tr key={appt.id}>
                                                    <td>#{appt.id}</td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-2">
                                                            <ImageShow url={appt.patient?.[0]?.profile_photo_url} width={30} height={30} style={{ borderRadius: '50%' }} />
                                                            <span>
                                                                {appt.patient?.[0]
                                                                    ? `${appt.patient[0].first_name || ''} ${appt.patient[0].last_name || ''}`.trim() || appt.patient[0].display_name
                                                                    : 'N/A'}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td>{appt.doctor?.[0]?.display_name || 'N/A'}</td>
                                                    <td>{appt.hospital?.[0]?.display_name || 'N/A'}</td>
                                                    <td>
                                                        <div className="d-flex flex-column">
                                                            <span style={{ fontWeight: '500' }}>{appt.appointment_date}</span>
                                                            <small className="text-muted">{appt.appointment_time}</small>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Badge bg={
                                                            appt.status === 'confirmed' ? 'success' :
                                                                appt.status === 'pending' ? 'warning' :
                                                                    appt.status === 'cancelled' ? 'danger' : 'info'
                                                        }>
                                                            {appt.status || 'Scheduled'}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <div className="dc-emptydata-holder p-5">
                                    <div className="dc-emptydata text-center">
                                        <em>No recent appointments found.</em>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="col-12 col-xs-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
                        <div className="dc-dashboardbox dc-dashboardtabsholder d-flex flex-column gap-2">
                            <div className="dc-dashboardboxtitle"><h2>Recent Activities</h2></div>
                            {recentActivities ? (
                                <div className="">
                                    <div className="">
                                        <div className="table-responsive">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Staff / User</th>
                                                        <th>Name</th>
                                                        <th>Type</th>
                                                        <th>Name</th>
                                                        <th>Time</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {recentActivities.map((activity) => (
                                                        <tr key={activity.id}>
                                                            <td>{activity.id}</td>
                                                            <td>
                                                                {activity.staff?.[0] ? (
                                                                    <ImageShow url={activity.staff[0].profile_photo_url} width={40} height={40} style={{ objectFit: 'cover', borderRadius: '50%' }} />
                                                                ) : activity.users?.[0] ? (
                                                                    <ImageShow url={activity.users[0].profile_photo_url} width={40} height={40} style={{ objectFit: 'cover', borderRadius: '50%' }} />
                                                                ) : (
                                                                    <ImageShow url={null} width={40} height={40} style={{ objectFit: 'cover', borderRadius: '50%' }} />
                                                                )}
                                                            </td>
                                                            <td>{activity.staff?.[0]?.display_name || activity.users?.[0]?.display_name || 'Unknown User'}</td>
                                                            <td>{activity.type}</td>
                                                            <td>{activity.name}</td>
                                                            <td>{new Date(activity.created_at).toLocaleString()}</td> {/* converted to local time */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="dc-emptydata-holder">
                                    <div className="dc-emptydata">
                                        <div className="dc-emptydetails dc-empty-booking dc-emptyholder-sm">
                                            <span></span>
                                            <em>No recent activities to show.</em>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="dc-uploadimages dc-package-modal modal fade" id="dc-package-details" tabIndex="-1" role="dialog" aria-hidden="true">
                        <div className="dc-modaldialog modal-dialog modal-dialog-centered" role="document">
                            <div className="dc-modalcontent modal-content">
                                <div className="dc-boxtitle">
                                    <h2>Standard<a href="javascript:;" data-dismiss="modal" aria-label="Close"><i className="dc-btncancel fa fa-times"></i></a></h2>
                                </div>
                                <div className="dc-modalbody modal-body">
                                    <div className="dc-dashboardboxcontent dc-packages">
                                        <div className="dc-package dc-packagedetails">
                                            <div className="dc-packagecontent">
                                                <ul className="dc-packageinfo">
                                                    <li><span>No of services per speciality</span></li>
                                                    <li><span>No of Brochures</span></li>
                                                    <li><span>No of Articles</span></li>
                                                    <li><span>No of Awards</span></li>
                                                    <li><span>No of Memberships</span></li>
                                                    <li><span>Private Quick Chat</span></li>
                                                    <li><span>Bookings</span></li>
                                                    <li><span>Featured Profile?</span></li>
                                                    <li><span>Featured days?</span></li>
                                                    <li><span>Duration</span></li>
                                                    <li><span>No Social Model Post</span></li>
                                                    <li><span>No Social Model Videos</span></li>
                                                    <li><span>Auto Post ?</span></li>
                                                    <li><span>Profile Website</span></li>
                                                    <li><span>HMS</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="dc-package dc-baiscpackage">
                                            <div className="dc-packagecontent">
                                                <ul className="dc-packageinfo">
                                                    <li><span>15&nbsp;</span></li>
                                                    <li><span>3&nbsp;</span></li>
                                                    <li><span>5&nbsp;</span></li>
                                                    <li><span>5&nbsp;</span></li>
                                                    <li><span>5&nbsp;</span></li>
                                                    <li><span><i className="ti-check"></i>&nbsp;</span></li>
                                                    <li><span><i className="ti-check"></i>&nbsp;</span></li>
                                                    <li><span><i className="ti-check"></i>&nbsp;</span></li>
                                                    <li><span>100&nbsp;</span></li>
                                                    <li><span>30&nbsp;</span></li>
                                                    <li><span>30&nbsp;</span></li>
                                                    <li><span>10&nbsp;</span></li>
                                                    <li><span><i className="ti-check"></i>&nbsp;</span></li>
                                                    <li><span><i className="ti-check"></i>&nbsp;</span></li>
                                                    <li><span><i className="ti-check"></i>&nbsp;</span></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>

    );
};

export default Dashboard;
